import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/custom-scrollbar";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {toggleScroll} from "./modules/toggleScroll";
import {headerSticky} from "./modules/headerSticky";
import {mainNav} from "./modules/mainNav";
import {stickyElement} from "./modules/stickyElement";
import {vimeoVideo} from "./modules/vimeoVideo";
import {trustedSlider} from "./modules/trustedSlider";
import {benefitsList} from "./modules/benefitsList";
import {customSelect} from "./modules/customSelect";
import {reviewsSlider} from "./modules/reviewsSlider";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {tabsSlider} from "./modules/tabsSlider";
import {accordion} from "./modules/accordion";
import {stepsSlider} from "./modules/stepsSlider";
import {logoSlider} from "./modules/logoSlider";
import {addScroll} from "./modules/addScroll";
import {careerSlider} from "./modules/careerSlider";
import {windowModal} from "./modules/windowModal";
import {inputFile} from "./modules/inputFile";
import {animationfunc} from "./modules/animationFunc";
import {parallax} from "./modules/parallax";
import {mixedSlider} from "./modules/mixedSlider";
import {footerFixed} from "./modules/footer";
import { notificationCookies } from "./modules/notificationCookies";
import { cleanStyles } from "./modules/cleanStyles";

binder({
    bounds: {
        "html": [constants, fullHeightPage,toggleScroll],
        ".header": [headerSticky, mainNav],
        ".sharing": stickyElement,
        ".vimeo-video": vimeoVideo,
        ".trusted-slider": trustedSlider,
        ".benefits-list": benefitsList,
        "select": customSelect,
        ".our-reviews-slider": reviewsSlider,
        ".testimonials-slider": testimonialsSlider,
        ".tabs-slider-wrap": tabsSlider,
        ".accordion": accordion,
        ".steps-slider-wrap": stepsSlider,
        ".logo-slider-container": logoSlider,
        ".slider-has-custom-scroll": addScroll,
        ".career-slider-section": careerSlider,
        ".our-team, .lang-menu-opener": windowModal,
        ".jobs-form": inputFile,
        "body": animationfunc,
        ".parallax": parallax,
        ".section-with-accordion": mixedSlider,
        ".footer": footerFixed,
        ".notification": notificationCookies,
        ".has-sidebar": cleanStyles,
    },
    runTests: false
});


// WEBPACK FOOTER //
// ./assets/js/global.js